import _ from "lodash";

class DesktopScaleLayoutStrategy {
  constructor(/** Object **/ config = {}) {
    this.config = config;
  }

  apply(/** ElementGroup **/ group) {
    let initialHeight = _.get(this.config, "initialHeight");
    let initialWidth = _.get(this.config, "initialWidth", 1200);
    let scaledWidth = _.get(this.config, "scaledWidth", 320);

    let aspectRatio = initialHeight / initialWidth;

    group.width = scaledWidth;
    let widthScale = group.width / initialWidth;
    group.height = Math.round(aspectRatio * group.width);

    _.each(group.elements, function (elementData) {
      let rect = _.clone(_.get(elementData, "rect"));
      let aspectRatio = rect.h / rect.w;

      rect.w = Math.round(widthScale * rect.w);
      rect.x = Math.round(widthScale * rect.x);

      let scaledHeight = Math.round(aspectRatio * rect.w);

      rect.y = Math.round((scaledHeight / rect.h) * rect.y);
      rect.h = scaledHeight;

      rect.x2 = rect.x + rect.w;
      rect.y2 = rect.y + rect.h;

      elementData.localRect = rect;
    });
  }
}

export default DesktopScaleLayoutStrategy;
